import type { Catalog } from "../en";

/** Filipino: console shell wiring (mirrors en/console.ts). */
export const consoleShell: Catalog["console"] = {
  loadingSession: "Sina-sign in ka…",
  sessionErrorTitle: "Hindi namin maabot ang Sagot",
  sessionErrorBody: "Tingnan ang iyong koneksyon, saka subukan muli. Ligtas ang iyong trabaho.",
  roleLine: "{{title}} · {{role}}",
  planLine: "{{plan}} plan · {{industry}}",
  planOnly: "{{plan}} plan",
  noNotificationsTitle: "Wala ka nang naiwan",
  noNotificationsBody: "Dito lalabas ang mga bagong handoff, natapos na upload at knowledge gap.",
  notificationsError: "Hindi ma-load ang mga abiso.",
  justNow: "Ngayon lang",
  agentsUnavailable: "Darating ang paglipat ng agent kasama ng Agents module.",
  chooseAgent: "Pumili muna ng agent",
  paletteActions: "Mga aksyon",
  palettePages: "Mga pahina",
  paletteWorkspaces: "Mga workspace",
  paletteSignOut: "Mag-sign out",
  paletteRoles: "Mga role at permission",
  paletteToggleTheme: "Lumipat sa {{theme}} na tema",
  signedOut: "Naka-sign out ka na",
  impersonationTitle: "Support view",
  impersonationBody: "Tinitingnan mo ang {{workspace}} bilang staff ng CRUD.IT. Itinatala ang bawat aksyon.",
  impersonationReadOnly: "Read-only",
  impersonationEnds: "Matatapos {{time}}",
  impersonationEnd: "Tapusin ang session",
  impersonationEnded: "Natapos ang support session",
  readOnlyTooltip: "Read-only sa session na ito",
  noPermission: "Wala kang pahintulot na gawin ito",
  forbiddenTitle: "Wala kang access sa pahinang ito",
  forbiddenBody: "Hindi kasama ang pahinang ito sa iyong role sa {{workspace}}. Lumapit sa Owner o Admin ng workspace kung kailangan mo ng access.",
  forbiddenBodyNoWorkspace: "Lumapit sa Owner o Admin ng workspace kung kailangan mo ng access.",
  noWorkspaceTitle: "Hindi available ang workspace na ito",
  noWorkspaceBody: "Maaaring inalis ka rito, o mali ang link.",
  goHome: "Pumunta sa aking workspace",
  roles: {
    owner: "Owner",
    admin: "Admin",
    editor: "Editor",
    agent: "Agent",
    viewer: "Viewer",
    field_engineer: "Field engineer",
    sales: "Sales",
  },
  plans: {
    starter: "Starter",
    standard: "Standard",
    pro: "Pro",
    institution: "Institution",
    trial: "Trial",
  },
  industries: {
    education: "Edukasyon",
    school: "Edukasyon",
    healthcare: "Healthcare",
    clinic: "Healthcare",
    real_estate: "Real estate",
    hospitality: "Hospitality",
    government: "Gobyerno",
    human_resources: "HR",
    ecommerce: "E-commerce",
    retail: "E-commerce",
    business: "Negosyo",
    general: "Negosyo",
    other: "Organisasyon",
  },
};
